export default __webpack_public_path__ + "static/media/clicktrades-logo.b58c3287.svg";